// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"18a611d3","594":"b4b98aee","938":"16510484"}[chunkId] + ".chunk.js";
};